import { useAppSelector } from '@app/hooks';
import { RootState } from '@app/store';
import GatewayVersions from '@features/home-status/components/GatewayVersions';
import SystemStatus from '@features/home-status/components/SystemStatus';
import { Box, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import HealthChecks from './HealthChecks';

const HomeHealth: FC = () => {
  const property = useAppSelector((state: RootState) => state.property);

  /** MAIN RENDER */
  return (
    <Box
      component="div"
      sx={{
        margin: '1em',
        padding: '2em',
      }}
    >
      <Typography variant="h4" sx={{ mb: 1 }}>
        Health status at {property?.name}
      </Typography>
      {property?.property_id && (
        <Typography
          variant="body2"
          sx={{
            fontFamily: 'monospace',
            fontSize: '0.85rem',
            color: 'text.secondary',
            cursor: 'pointer',
            mb: 1,
            '&:hover': { color: 'primary.main' },
          }}
          onClick={() => navigator.clipboard.writeText(property.property_id)}
          title="Click to copy Kiosk ID"
        >
          Kiosk ID: {property.property_id}
        </Typography>
      )}
      <Stack direction="column" spacing={2} sx={{ pt: 6 }}>
        <SystemStatus />
        <GatewayVersions />
        <HealthChecks />
      </Stack>
    </Box>
  );
}

export default HomeHealth;